import {inject, provider} from "react-ioc";
import {observer} from "mobx-react";
import React, {Component} from "react";
import {OrganizationNewStore} from "app/modules/admin/components/organizations/new/OrganizationNewStore";
import {Divider, Grid, Stack, TextField, Typography} from "@mui/material";
import {PageTitleDetails} from "app/modules/common/layout/components/page-title";
import {Container, ContainerDetails} from "app/modules/common/layout/components/containers";
import {LoadingButton} from "@mui/lab";
import {NavigateHook} from "app/modules/common/layout/hooks/navigate-hook";
import {Paths} from "app/modules/admin/stores/paths";

@provider(OrganizationNewStore)
@observer
export default class Index extends Component<any, any> {
    @inject organizationNewStore: OrganizationNewStore;

    render() {
        if(this.organizationNewStore.isSavedSuccessfully) {
            return <NavigateHook path={Paths.Organizations.nav}/>;
        }

        return <Container>
            <PageTitleDetails Title={"New Organization"} Size={8}/>
            <Grid item xs={4} sx={{ pb: 4 }} textAlign={"right"}>
                <LoadingButton loading={this.organizationNewStore.isLoading} disabled={this.organizationNewStore.formState.hasError} variant="contained" onClick={this.organizationNewStore.save}>
                    Save
                </LoadingButton>
            </Grid>
            <ContainerDetails>
                <Grid item xs={4} textAlign={"right"}>
                    <Typography variant="h5" component="div">
                        Basic Info
                    </Typography>
                    <Divider light />
                </Grid>
                <Grid item xs={8} sx={{ pl: 4 }}>
                    <Stack spacing={2} direction={"column"}>
                        <div>
                            <TextField
                                fullWidth
                                value={this.organizationNewStore.formState.$.companyName.value || ''}
                                error={this.organizationNewStore.formState.$.companyName.hasError}
                                helperText={this.organizationNewStore.formState.$.companyName.error}
                                onChange={(e)=>this.organizationNewStore.formState.$.companyName.onChange(e.target.value)}
                                label="Company Name"
                                variant="standard"
                            />
                        </div>
                        <div>
                            <Stack spacing={2} direction={"row"}>
                                <TextField
                                    sx={{ width: "50%" }}
                                    value={this.organizationNewStore.formState.$.ownerName.value || ''}
                                    error={this.organizationNewStore.formState.$.ownerName.hasError}
                                    helperText={this.organizationNewStore.formState.$.ownerName.error}
                                    onChange={(e)=>this.organizationNewStore.formState.$.ownerName.onChange(e.target.value)}
                                    label="Owner Name"
                                    variant="standard"
                                />
                                <TextField
                                    sx={{ width: "50%" }}
                                    value={this.organizationNewStore.formState.$.ownerEmail.value || ''}
                                    error={this.organizationNewStore.formState.$.ownerEmail.hasError}
                                    helperText={this.organizationNewStore.formState.$.ownerEmail.error}
                                    onChange={(e)=>this.organizationNewStore.formState.$.ownerEmail.onChange(e.target.value)}
                                    label="Owner Email"
                                    variant="standard"
                                />
                            </Stack>
                        </div>
                    </Stack>
                </Grid>
            </ContainerDetails>
        </Container>;
    }
}
